import React from 'react';
import { Avatar, AvatarGroup } from '@carnica/ui-kit';
import { defineUrlIcon } from '@carnica/graphics';

import { FUB_COMMON_STATUS } from 'constants/accumulators';

type GroupRightSideProps = {
  avatarImage: string;
  isError: boolean;
  items:
    | {
        icon: ReturnType<typeof defineUrlIcon>;
      }[]
    | undefined;
  status: string;
};

export const GroupRightSide: React.FC<GroupRightSideProps> = ({
  avatarImage,
  isError,
  items,
  status,
}) => {
  const showAvatarGroup = [FUB_COMMON_STATUS.SLAVE, FUB_COMMON_STATUS.MASTER].includes(
    status.toLowerCase(),
  );

  if (isError || !showAvatarGroup) {
    return <Avatar image={avatarImage} size="s" />;
  }

  return <AvatarGroup items={items} size="s" style={{ width: 'auto' }} visibleCount={4} />;
};
